import { noSeq, outsideTree, srceNames, srceSeqIds, fetchSNPDistance} from "../../utils/utils";

import React, { useEffect, useState } from 'react';
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Table from "react-bootstrap/Table";
import { useApi } from "../../contexts/ApiProvider";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function MissingSrces({ ptObj }) {
  const api = useApi();
  const snp_dist = useSelector((state) => state.patient.snp_distance);
  const [UniqueSourcesWithSeqId, setUniqueSourcesWithSeqId] = useState([]);
  const [UniqueSourcesWithoutSeqId, setUniqueSourcesWithoutSeqId] = useState([]);

  const navigate = useNavigate();
  
  const handleRowClick = (micro_id) => {
    navigate(`/patient/${micro_id}`);
  };

  useEffect(() => {
    const index_seq_id = ptObj.pt.seq_id;
    const srces = srceNames(ptObj);
    const withSeqId = srces.filter(item => item.seq_id !== null);
    const withoutSeqId = srces.filter(item => item.seq_id === null);
    setUniqueSourcesWithoutSeqId(Array.from(new Map(withoutSeqId.map(item => [item.name, item])).values()));
    
    if (index_seq_id && withSeqId.length > 0) {
      fetchSNPDistance(api, index_seq_id, withSeqId)
        .then(withSeqIdWithDist => {
          // console.log('withSeqIdWithDist', withSeqIdWithDist);
          // console.log(snp_dist);
          
          // Filter for distances <= snp_dist
          const filteredSources = withSeqIdWithDist.filter(item => item.dist > snp_dist);
          // console.log('filteredSources', filteredSources);
          const uniqueSources = Array.from(new Map(filteredSources.map(item => [item.seq_id, item])).values());
          // console.log('uniqueSources', uniqueSources);
          setUniqueSourcesWithSeqId(uniqueSources.sort((a, b) => a.dist - b.dist)); // Sorting by distance
        })
        .catch(error => {
          console.error("Failed to fetch or add distances:", error);
        });
    }
  }, [api, ptObj, snp_dist]);

  return (
    <div>
    <Row>
      <Col md={12}>
        <Row>
          <Col md={6}>
            <div style={{ fontSize: '14px', }}>Overlap sources with SNP distance ≥{snp_dist}:</div>
            {UniqueSourcesWithSeqId.length > 0 && (
              <Table hover className='excluded-table' style={{ marginTop: 10}}>
                <thead>
                  <tr>
                    <th style={{ fontSize: '12px', fontWeight: 500 }}>Name</th>
                    <th style={{ fontSize: '12px', fontWeight: 500 }}>SNP Distance</th>
                  </tr>
                </thead>
                <tbody>
                  {UniqueSourcesWithSeqId.map((entry, index) => (
                    <tr key={index} onClick={() => handleRowClick(entry.micro_id)} style={{cursor: 'pointer'}}>
                      <td>{entry.name}</td>
                      <td>{entry.dist <= 9999 ? entry.dist : ">9999"}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Col>
          <Col md={6}>
          <div style={{ fontSize: '14px'}}>Overlap sources without sequencing data:</div>
            {UniqueSourcesWithoutSeqId.length > 0 && (
              <Table hover className="noSeq-table" style={{ marginTop: 10}}>
                <thead>
                  <tr>
                    <th style={{ fontSize: '12px', fontWeight: 500 }}>Name</th>
                  </tr>
                </thead>
                <tbody>
                  {UniqueSourcesWithoutSeqId.map((entry, index) => (
                    <tr key={index} onClick={() => handleRowClick(entry.micro_id)} style={{cursor: 'pointer'}}>
                      <td>{entry.name}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  </div>
  );
}